import { render, staticRenderFns } from "./ChampionshipsListFilter.vue?vue&type=template&id=60eea217&"
import script from "./ChampionshipsListFilter.vue?vue&type=script&lang=js&"
export * from "./ChampionshipsListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports